export default __webpack_public_path__ + "static/media/icon-discover.97bc297fa11c53b4bcaa7126ce5a72ee.svg";